import React from "react";
import { Input, Select, Button, Space } from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
const { Option } = Select;

export default function ECATableFilters({ filtros, onFiltrosChange, proyectoCodigo }) {

  const limpiarFiltros = () => {
  onFiltrosChange({
    busqueda: "",
    tipoEstado: [],
    sesiones: [],
    proyecto: proyectoCodigo ? filtros.proyecto : null,
  });
};

  const hayFiltrosActivos =
    filtros.busqueda ||
    filtros.tipoEstado.length > 0 ||
    filtros.sesiones.length > 0 ||
    !!filtros.proyecto;

  return (
    <div style={{ marginBottom: 24 }}>
      <Space wrap align="end" size={[16, 16]} style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        <div style={{ width: 280 }}>
          <label style={{ display: "block", marginBottom: 4 }}>
            Buscar Sesiones de ECA's
          </label>
          <Input
            placeholder="Nombre de las sesiones de ECA's"
            prefix={<SearchOutlined />}
            value={filtros.busqueda}
            onChange={(e) =>
              onFiltrosChange({ ...filtros, busqueda: e.target.value })
            }
            allowClear
          />
        </div>

        <div style={{ width: 250 }}>
          <label style={{ display: "block", marginBottom: 4 }}>
            Tipo de Temática
          </label>
          <Select
            mode="multiple"
            value={filtros.tipoEstado}
            onChange={(value) =>
              onFiltrosChange({ ...filtros, tipoEstado: value })
            }
            style={{ width: "100%" }}
            placeholder="Selecciona una o varias"
            allowClear
          >
            <Option value="1">Técnico</Option>
            <Option value="2">Ambiental</Option>
            <Option value="3">Socioempresarial</Option>
            <Option value="4">Comercial</Option>
            <Option value="5">DHAA</Option>
            <Option value="6">Enfoque Diferencial</Option>
          </Select>
        </div>
        <div style={{ width: 250 }}>
          <label style={{ display: "block", marginBottom: 4 }}>
            Filtrar por Sesión
          </label>
          <Select
            value={filtros.sesiones}
            onChange={(value) =>
              onFiltrosChange({ ...filtros, sesiones: value })
            }
            style={{ width: "100%" }}
            placeholder="Selecciona una o varias sesiones"
            allowClear
          >
            {[
              ...new Set(filtros.listaSesiones) // ✅ Evitar duplicados
            ].map((nombre) => (
              <Option key={nombre} value={nombre}>
                {nombre}
              </Option>
            ))}
          </Select>
        </div>
        <div style={{ width: 300 }}>
          <label style={{ display: "block", marginBottom: 4 }}>
            Proyecto
          </label>

          <Select
  disabled={!!proyectoCodigo}
  value={filtros.proyecto}
  onChange={(value) =>
    onFiltrosChange({ ...filtros, proyecto: value })
  }
  style={{ width: "100%" }}
  placeholder="Selecciona un proyecto"
  allowClear
  showSearch
  optionFilterProp="children"
>
            {(filtros.listaProyectos || []).map((p) => (
              <Option key={String(p.id_proyecto)} value={String(p.id_proyecto)}>
                {p.proyecto || p.codigo_proyecto || `Proyecto ${p.id_proyecto}`}
              </Option>
            ))}
          </Select>
        </div>
        {hayFiltrosActivos && (
          <div style={{ width: 100 }}>
            <Button
              type="default"
              icon={<CloseOutlined />}
              onClick={limpiarFiltros}
              danger
              block
            >
              Limpiar
            </Button>
          </div>
        )}
      </Space>
    </div>
  );
}
